import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
} from "@material-ui/core";

import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { putCerrarInternacionDomiciliaria } from "../../../../actions/autorizaciones/Autorizaciones";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";

export const ModalCierreInterDom = (props) => {
  const dispatch = useDispatch();

  const { motivosCierreInterDom = [], solicitudSeleccionada } = useSelector(
    (state) => state.autorizaciones
  );

  const [idMotivo, setIdMotivo] = useState();
  const [fecha, setFecha] = useState(moment());

  const onSubmitHandler = (e) => {
    let data = {
      fechaEgreso: fecha,
      idSolicitud: props.idSolicitud,
      idMotivoCierre: idMotivo,
    }

    dispatch(putCerrarInternacionDomiciliaria(data, props.close, props.onCloseModalAuditar, props.filtros));
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={props.open} onClose={props.close}>
      <DialogTitle>{props.titulo}</DialogTitle>
      <DialogContent>
        <ValidatorForm onSubmit={onSubmitHandler}>
          <Grid container spacing={2}>
            <Grid item xs={10} sm={10} md={8} lg={6} style={{paddingLeft: 16}}>
              <MuiPickersUtilsProvider
                  locale={esLocale}
                  utils={DateFnsUtils}
              >
                  <KeyboardDatePicker
                      margin="normal"
                      id="dialogFechaInicio"
                      label="Fecha Alta"
                      format="dd/MM/yyyy"
                      okLabel="Aceptar"
                      required={true}
                      disabled={props.disabled}
                      minDate={moment(solicitudSeleccionada.fechaIngreso).format("YYYY-MM-DD") < moment().subtract(60, 'days').format("YYYY-MM-DD")
                                ? moment().subtract(60, 'days').format("YYYY-MM-DD")
                                : moment(solicitudSeleccionada.fechaIngreso).add(1, 'days').format("YYYY-MM-DD")
                              }
                      minDateMessage={`La fecha no puede ser anterior a la Fecha de Ingreso`}
                      //maxDate={moment().add(1, 'days').format("YYYY-MM-DD")}
                      //maxDateMessage={`La fecha no puede ser posterior a la fecha actual`}
                      clearLabel="Limpiar"
                      cancelLabel="Cancelar"
                      value={
                          moment(fecha).isValid()
                          ? moment(fecha)
                          : null
                      }
                      onChange={(date) => {
                          setFecha(date);
                      }}
                      KeyboardButtonProps={{
                          "aria-label": "change date",
                      }}
                  />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={10} sm={10} md={8} lg={6} style={{alignSelf: 'center', paddingLeft: 16}}>
              {Array.isArray(motivosCierreInterDom) &&
                  motivosCierreInterDom?.length > 0 && (
                    <SelectValidator
                      fullWidth
                      label="Motivo de Cierre"
                      name="idMotivo"
                      value={idMotivo?? ''}
                      onChange={(e) => setIdMotivo(e.target.value)}
                      validators={["required"]}
                      errorMessages={["Este campo es requerido"]}
                    >
                      {motivosCierreInterDom.map((item) => (
                        <MenuItem
                          key={item.idMotivoCierre.toString()}
                          value={item.idMotivoCierre}
                        >
                          {`${item.descripcion}`}
                        </MenuItem>
                      ))}
                    </SelectValidator>
              )}
            </Grid>
          </Grid>
          <div
            style={{
              margin: "1rem 0",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
          >
            <Button variant="contained" color="primary" onClick={props.close}>
              Cancelar
            </Button>
            <Button type="submit" variant="contained" disabled={props.disabled} color="primary">
              Guardar
            </Button>
          </div>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};
